import {
  ShieldCheck, Zap, Layers, Landmark, Coins, TrendingUp, Monitor, Globe,
  Wallet, CreditCard, Star, UserPlus, Bot, LineChart, Headphones, Bitcoin,
  Calendar, Gift, Award, Lock,
} from "lucide-react";

// Preset gold-icon set shared by public panels (Home) and the Admin Sections editor.
export const PANEL_ICONS = {
  shield: ShieldCheck,
  zap: Zap,
  layers: Layers,
  landmark: Landmark,
  coins: Coins,
  "trending-up": TrendingUp,
  monitor: Monitor,
  globe: Globe,
  wallet: Wallet,
  card: CreditCard,
  star: Star,
  "user-plus": UserPlus,
  bot: Bot,
  chart: LineChart,
  support: Headphones,
  bitcoin: Bitcoin,
  calendar: Calendar,
  gift: Gift,
  award: Award,
  lock: Lock,
};

export const ICON_NAMES = Object.keys(PANEL_ICONS);
